import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function weightFormatValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return { required: true };
        }

        const regex = /^\d{1,2}\.\d{3}-\d{1,2}\.\d{3}$/;

        return regex.test(value) ? null : { weightFormat: true };
    };
}
